import { parseScreenshotIds } from '../../implementation-examples/helpers/implementationExamplePaths'
import { BulkAssignSelection } from '../types/ImplementationBulkAssign'

export const implementationBulkAssignPath = '/internal/implementation-bulk-assign'

export const bulkAssignEditPath = `${implementationBulkAssignPath}/edit`

export const getBulkAssignEditPath = (selection?: string) =>
  selection ? `${bulkAssignEditPath}?selection=${encodeURIComponent(selection)}` : bulkAssignEditPath

// Commas stay readable, as in legacy's request URLs.
const listQuery = (entries: [string, (string | number)[]][]) =>
  entries
    .filter(([, values]) => values.length)
    .map(([key, values]) => `${key}=${values.map((value) => encodeURIComponent(String(value))).join(',')}`)
    .join('&')

export const getBulkAssignFeaturesPath = ({ choiceIds, conceptIds }: BulkAssignSelection) => {
  const query = listQuery([
    ['choices', choiceIds],
    ['concepts', conceptIds],
  ])
  return `${implementationBulkAssignPath}/features${query ? `?${query}` : ''}`
}

export const getBulkAssignGamesPath = (gameIds: string[]) => {
  const query = listQuery([['gameIds', gameIds]])
  return `${implementationBulkAssignPath}/games${query ? `?${query}` : ''}`
}

export const parseChoiceIds = (value: string | null) =>
  parseScreenshotIds(value)
    .filter((id) => /^\d+$/.test(id))
    .map(Number)

export const parseBulkAssignSelection = (params: URLSearchParams): BulkAssignSelection => ({
  choiceIds: parseChoiceIds(params.get('choices')),
  conceptIds: parseScreenshotIds(params.get('concepts')),
})
